<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      :raw-data="players"
      :plot-options="{bar: {horizontal: false, borderRadius: 10, dataLabels: {position: 'center', orientation: 'vertical'}}}"
      :chart-value-keys="chartValueKeys"
      x-value="last_name"
      :y-value-prefix="aggregation && !removable ? 'latest_stats.' : 'player_stats.'"
      :data-labels="{enabled: true, enabledOnSeries: [0], formatter: function (val, {dataPointIndex}) {
        return labels.totalDist[dataPointIndex] !== undefined && labels.totalDist[dataPointIndex] !== null ? labels.totalDist[dataPointIndex] + '%' : ''
      }}"
      :markers="{size: 5}"
      :yaxis="[{ title: { text: $t('chart_legends.distance') }}, { title: { text: getUnitSuffixForUser('m/min') }, opposite: true } ]"
      :colors="['#008FFB','#00E396']"
      :xaxis="{
        labels: {
          rotate: -45
        },
        categories: players.map(p => p.first_name[0] + '. ' + p.last_name ),
        tickPlacement: 'between'
      }"
    >
      <template v-slot:header>
        <v-card-title class="pa-6 d-flex justify-space-between">
          <div class="subtitle-2 grey--text text--grey-100">
            {{ $t('card_title.total_distance_and_m_min') }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
          </div>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
          <visual-list-toggle
            v-else
            :value.sync="viewMode"
          />
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t('card_title.total_distance_and_m_min') }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
        </div>
        <div class="d-flex align-center">
          <visual-list-toggle
            v-if="!removable"
            :value.sync="viewMode"
          />
        </div>
      </v-card-title>

      <v-data-table
        :headers="tableHeaders"
        :items="players"
        hide-default-footer
        disable-pagination
        :items-per-page="-1"
        fixed-header
        :height="350"
      >
        <template v-slot:item.last_name="{ item }">
          {{ item.last_name }}, {{ item.first_name }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'
import { getUnitSuffixForUser } from '@/utils/helpers'

export default {
  name: 'TotalDistanceChart',
  components: { LineChart, VisualListToggle },
  props: {
    players: {
      type: Array,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    },
    aggregation: {
      type: String,
      default: null
    }
  },
  data: () => ({
    labels: {},
    viewMode: 'chart'
  }),
  computed: {
    chartValueKeys() {
      return [
        { key: this.getKeyWithAggregation('UXPCSTD'), type: 'bar', label: this.$t('variables.UXPCSTD') },
        { key: this.getKeyWithAggregation('UXPCSMYPM'), label: this.$t('variables.UXPCSMYPM') }
      ]
    },
    tableHeaders() {
      return [
        {
          text: this.$t('table_headers.name'),
          value: 'last_name',
          sortable: true,
          width: '30%'
        },
        {
          text: this.$t('variables.UXPCSTD'),
          value: (this.aggregation && !this.removable ? 'latest_stats.' : 'player_stats.') + this.getKeyWithAggregation('UXPCSTD'),
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('variables.UXPCSMYPM'),
          value: (this.aggregation && !this.removable ? 'latest_stats.' : 'player_stats.') + this.getKeyWithAggregation('UXPCSMYPM'),
          sortable: true,
          align: 'center'
        }
      ]
    }
  },
  created() {
    this.labels.totalDist = this.players.map(player => player.player_stats?.UXPCSTD_GALL)
  },
  methods: {
    getUnitSuffixForUser,
    getKeyWithAggregation(key) {
      return this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
    }
  }
}
</script>
